export const toCamelCase = (str) => {
    if (typeof str !== 'string') return str;
    return str.toLowerCase().replace(/_([a-z])/g, (_, match) => match.toUpperCase());
};

export const toSnakeCase = (str) => {
    return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
};

export const lowercaseFirstLetter = (str) => {
    if (typeof str !== 'string' || str.length === 0) return str;
    return str.charAt(0).toLowerCase() + str.slice(1);
};

export const isSnakeCase = (str) => {
    return /^[a-z]+(_[a-z]+)*$/.test(str);
};

export const convertKeysToCamelCase = (obj) => {
    const result = {};

    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            const value = obj[key];
            if (typeof value === 'string' && isSnakeCase(key)) {
                const camelCaseKey = toCamelCase(key);
                result[camelCaseKey] = value;
            } else {
                result[key] = value;
            }
        }
    }

    return result;
};


// WEBPACK FOOTER //
// ./src/components/common/form/DBEnumStringHelper.js